import { FC } from "react";
import OrderDetailsToolsTranslations from "../../../../../languages/types/order/details/order-details-tools.translation";
import OrderDetailsToolButtonComponent from "../../common/tool-button/order-details-tool-button.component";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { OrderDetailsToolsPropsStatus } from "../types/order-details-tools";
import orderService from "../../../../../common/services/order/order.service";
import useAbort from "../../../../../common/hooks/use-abort";
import { OrderCargoOrderChangeApprovalStatusParamsApprovalStatus } from "../../../../../common/services/order/cargo-order/change-approval-status/order-cargo-order-change-approval-status-params";
import notificationService from "../../../../../common/utils/notification/notification.service";

type OrderDetailsAcceptComponentProps = {
  tools: OrderDetailsToolsTranslations;
  status: OrderDetailsToolsPropsStatus | null;
  orderId: string;
  onOrderAccept: () => void;
  hasAccess: boolean;
};

const OrderDetailsAcceptComponent: FC<OrderDetailsAcceptComponentProps> = ({
  orderId,
  status,
  tools,
  onOrderAccept,
  hasAccess,
}) => {
  const changeApprovalStatusAbort = useAbort();

  if (!hasAccess) return null;
  if (!status) return null;

  const isDisabled = [
    OrderDetailsToolsPropsStatus.CANDIDATURE,
    OrderDetailsToolsPropsStatus.IN_PROGRESS,
    OrderDetailsToolsPropsStatus.PLANNED,
    OrderDetailsToolsPropsStatus.ACCEPTED,
  ].includes(status);

  return (
    <OrderDetailsToolButtonComponent
      icon={faCheck}
      type="success"
      title={tools.acceptButtonTitle}
      onClick={() => {
        orderService
          .changeApprovalStatus(
            {
              orderUuid: orderId,
              status:
                OrderCargoOrderChangeApprovalStatusParamsApprovalStatus.ACCEPTED,
            },
            changeApprovalStatusAbort.signal,
          )
          .then(() => {
            onOrderAccept();
            notificationService.success(tools.acceptSuccessNotification);
          })
          .catch(() => {
            notificationService.error(tools.acceptFailureNotification);
          });
      }}
      isDisabled={isDisabled}
    />
  );
};

export default OrderDetailsAcceptComponent;
